import ButtonDisplay from './button/button-display.component.jsx';
import ContactFormDisplay from './contact-form/contact-form-display.component.jsx';
import DividerDisplay from './divider/divider-display.component.jsx';
import ImageDisplay from './image/image-display.component.jsx';
import ParagraphDisplay from './paragraph/paragraph-display.component.jsx';
import ProductSlideshowDisplay from './product-slideshow/product-slideshow-display.component.jsx';
import SpacerDisplay from './spacer/spacer-display.component.jsx';
import SubtitleDisplay from './subtitle/subtitle-display.component.jsx';
import TitleDisplay from './title/title-display.component.jsx';
import YouTubeDisplay from './youtube/youtube-display.component.jsx';

const sectionDisplayMap = {
  button: ButtonDisplay,
  contactForm: ContactFormDisplay,
  divider: DividerDisplay,
  image: ImageDisplay,
  paragraph: ParagraphDisplay,
  productSlideshow: ProductSlideshowDisplay,
  spacer: SpacerDisplay,
  subtitle: SubtitleDisplay,
  title: TitleDisplay,
  youtube: YouTubeDisplay,
};

export default sectionDisplayMap;